import Checkbox from "./Checkbox.jsx";
import DropSelect from "./DropSelect.jsx";
import Input from './Input.jsx';
import CollectionItem from './CollectionItem.jsx';
import Radio from './Radio.jsx';
import NumberInput from "./NumberInput.jsx";
import PasswordInput from './PasswordInput.jsx';
import TextArea from './TextArea.jsx';
import FontPicker from "./FontPicker.jsx";

const FieldTypes = {
    Checkbox,
    CollectionItem,
    DropSelect,
    Dropdown: DropSelect,
    FontPicker,
    Input,
    Number: NumberInput,
    PasswordInput,
    NumberInput,
    Radio,
    TextArea
};

export default FieldTypes;
